import { motion } from "framer-motion";
import ListItem from "@/components/ListItem";
import telliIcon from "@/assets/icons/telli.webp";

const currentItems = [
  { icon: telliIcon, title: "Telli", subtitle: "Growth & Founders Associate", hideAction: true },
];

const CurrentStatus = () => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ delay: 0.15, duration: 0.5 }}
  >
    {currentItems.map((item, i) => (
      <ListItem key={item.title} {...item} delay={0.05 * i} />
    ))}
  </motion.div>
);

export default CurrentStatus;
